import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_BACKLOG } from 'constants/eventManager.constant';

import { UserWithAvatar } from 'interfaces/user.interface';

import { BacklogIcon } from '@common_components/icons/backlog.icon';
import { LoggerService } from '@umanforge/common';

import defaultAvatar from '../../assets/default_avatar.png';
import { StyleEventCard } from 'enum/styleEventCard.enum';


interface UserCardProps {
  person: UserWithAvatar;
  style?: StyleEventCard;
}

const UserCard: React.FC<UserCardProps> = ( { person, style = StyleEventCard.square } ) => {
  const { t } = useTranslation();

  const logger: LoggerService = new LoggerService( `UserCard ${ person.id }` );

  const [ avatarUrl, setAvatarUrl ] = useState<string>( person.avatar ?? defaultAvatar );

  useEffect( () => {
    if ( person.avatar && person.avatar != avatarUrl ) {
      setAvatarUrl( person.avatar );
    }
  }, [ person.id ] );

  return (
    <div
      className={`
        flex h-full flex-center w-full min-h-24 h-fit px-2 relative group trans-fast
        ${ style === StyleEventCard.square ? 'flex-col min-h-44' : 'min-h-32' }
      `}
    >
      <div
        className={`
          bg-white border-2 trans-fast border-transparent border-r-orange-400 text-gray-400 z-10 flex-center shadow dark:bg-dark-bg-light rounded-l-xl h-20 w-20 overflow-hidden
          ${ style === StyleEventCard.square ? '' : 'w-1/3' }
        `}
      >
        {
          person.id === DEFAULT_BACKLOG.ID ? (
            <BacklogIcon size={12} className='ml-[18px]' />
          ) : (
            <img
              src={avatarUrl}
              alt={ `${person.firstname || ''} ${person.lastname || ''}`.trim() || person.id }
              draggable={false}
              className={ ( avatarUrl === defaultAvatar ? 'w-12 h-12' : 'w-20 h-20' ) + ' object-cover rounded-l-xl' }
              onError={ () => {
                logger.warn( 'Avatar load failed for user', person.id, avatarUrl );
                setAvatarUrl( defaultAvatar );
              } }
            />
          )
        }
      </div>
      <div className={ `flex flex-center px-1 py-0.5 ${ style === StyleEventCard.square ? '' : 'w-2/3 min-h-20 bg-white rounded-xl pl-3 -ml-2' }` }>
        <div className="flex flex-col items-center text-base z-10">
          {
            person.isAdmin && (
              <span className={ `text-[10px] text-gray-600 italic ${ style === StyleEventCard.square ? '' : 'order-last' }` }> ({ t( 'common:administrator' ) }) </span>
            )
          }
          <span className={ `line-clamp-3 text-center break-words ${ style === StyleEventCard.square ? '' : 'text-[18px]' }` }>
            {
              person.id == DEFAULT_BACKLOG.ID && person.firstname == DEFAULT_BACKLOG.NAME ?
                t( 'translation:' + person.firstname )
                :
                person.firstname
            } {
              person.lastname && person.lastname.trim() !== '' ? person.lastname : ''
            }
          </span>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
